var render = function render(){var _vm=this,_c=_vm._self._c;return _c('message-bubble',{attrs:{"isMine":_vm.isMine,"message":_vm.message}},[_c('video',{staticClass:"video",attrs:{"src":_vm.payload.videoUrl,"controls":""},on:{"error":_vm.videoError}}),(_vm.showProgressBar)?_c('van-progress',{attrs:{"percentage":_vm.percentage,"color":_vm.progressColor}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }